// Typographic gold wordmark for the SARRGOSA project logo.
export function Wordmark({ className = "", size = "text-2xl" }) {
  return (
    <span
      data-testid="sarrgosa-wordmark"
      className={`font-serif-lux ${size} tracking-[0.28em] gold-gradient-text select-none ${className}`}
    >
      SARRGOSA
    </span>
  );
}
